declare function require(moduleName: any): any;

export const environment = {
  typeForm: 'CzfYt6Mh',
  production: true,
  env: 'prod',
  apiUrlMock: 'http://localhost:3000',
  apiUrl: 'https://api.marsaude.net/v1',
  urlAppUser: 'https://app.marsaude.net',
  loginRedirect: 'https://admin.marsaude.net',
  professional: 'https://atendimento.marsaude.net',
  version: require('../../package.json').version,
  build: require('../../package.json').build,
  company: {
    name: 'Mar Saúde',
  },
  aggrid: 'Using_this_{AG_Grid}_Enterprise_key_{AG-104927}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{MAR_Algoritmos_de_Sade_LTDA}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Mar_Saude}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Mar_Saude}_need_to_be_licensed___{Mar_Saude}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{10_November_2026}____[v3]_[01]_MTc5NDI2ODgwMDAwMA==5a3fb0836a8a2087993857b41c0ee11f',
  presharedKey: 'DK8GyrYYs/cqjZ6s6yl8L44BKPDbD/l/dhLCJxUyqoKkjsm2TkyXLuThmj5bdUZKZd5m4Rc/rop7rSY1uvPDDw==',
};
